import { render, staticRenderFns } from "./PoweredbyIcon.vue?vue&type=template&id=7c43f205&scoped=true&"
import script from "./PoweredbyIcon.vue?vue&type=script&lang=js&"
export * from "./PoweredbyIcon.vue?vue&type=script&lang=js&"
import style0 from "./PoweredbyIcon.vue?vue&type=style&index=0&id=7c43f205&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c43f205",
  null
  
)

export default component.exports